import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text, Image } from '@chakra-ui/react';
import CloseIcon from './svgIcon/close';
import RightArrowWhiteIcon from '../../static/new_images/white-arrow.svg';
import download from '../utils/download';

const SmartBanner = ({ closeSmartBanner }) => (
  <Flex
    bg="font.highlight"
    h={{ base: '58px' }}
    justify={{ base: 'flex-start', sm: 'center' }}
    align="center"
    p="12px 20px"
    position="sticky"
    top="0"
    w="100%"
    zIndex="4"
  >
    <Box w="13px" h="13px" borderRadius="10px" bg="#fff" mr={{ base: '16px', sm: '8px' }} />
    <Text
      color="#fff"
      fontSize="14px"
      fontWeight={500}
      lineHeight="17px"
      w={{ base: '180px', sm: 'auto' }}
      onClick={download}
    >
      Ready to dive into Web3? Download Blocto Wallet
    </Text>
    <Image onClick={download} ml={{ base: '21px', sm: '13px' }} src={RightArrowWhiteIcon} />
    <Box position="absolute" right="20px" onClick={closeSmartBanner} cursor="pointer">
      <CloseIcon fill="#fff" />
    </Box>
  </Flex>
);

SmartBanner.propTypes = {
  closeSmartBanner: PropTypes.func.isRequired,
};

export default SmartBanner;
